import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div style={{backgroundColor:'lightblue', display:'grid', height:'100vh', placeContent:'center'}}>
      <h1 style={{backgroundColor:"yellow", color:"blue"}}>Hello World!</h1>
      <h2>And Hello React!!!</h2>
    </div>
  );
}

export default App;
